/** Cookie consent preference (essential auth cookies are always allowed). */

export const COOKIE_CONSENT_KEY = "nh_cookie_consent";

export function readCookieConsent() {
  try {
    const raw = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed?.choice === "accepted" || parsed?.choice === "rejected") {
      return parsed;
    }
  } catch {
    /* ignore corrupt storage */
  }
  return null;
}

export function writeCookieConsent(choice) {
  const payload = {
    choice,
    at: new Date().toISOString(),
  };
  localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(payload));
  return payload;
}

/** True when the user accepted non-essential cookies (for future analytics tags). */
export function hasAcceptedNonEssentialCookies() {
  return readCookieConsent()?.choice === "accepted";
}
